export default __webpack_public_path__ + "static/media/thumb.7b3ecad3.svg";